/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Tabs_FilesInputs */

const id_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File`)
};

const ms_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fail`)
};

const da_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filer`)
};

const de_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateien`)
};

const en_us2_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files`)
};

const es_es2_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos`)
};

const es_mx2_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos`)
};

const fil_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga File`)
};

const fr_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichiers`)
};

const it_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File`)
};

const hu_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fájlok`)
};

const nl_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestanden`)
};

const no_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filer`)
};

const pl_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pliki`)
};

const pt_br2_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivos`)
};

const pt_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ficheiros`)
};

const ro_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fișiere`)
};

const fi_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiedostot`)
};

const sv_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filer`)
};

const vi_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tệp`)
};

const tr_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosyalar`)
};

const cs_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soubory`)
};

const bg_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файлове`)
};

const ru_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файлы`)
};

const uk_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файли`)
};

const ar_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الملفات`)
};

const hi_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइलें`)
};

const th_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไฟล์`)
};

const ja_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイル`)
};

const zh_cn2_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件`)
};

const zh_hant1_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`檔案`)
};

const ko_builds_tabs_files = /** @type {(inputs: Builds_Tabs_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파일`)
};

/**
* | output |
* | --- |
* | "Files" |
*
* @param {Builds_Tabs_FilesInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_tabs_files = /** @type {((inputs?: Builds_Tabs_FilesInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Tabs_FilesInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_tabs_files(inputs)
	if (locale === "ms") return ms_builds_tabs_files(inputs)
	if (locale === "da") return da_builds_tabs_files(inputs)
	if (locale === "de") return de_builds_tabs_files(inputs)
	if (locale === "en-US") return en_us2_builds_tabs_files(inputs)
	if (locale === "es-ES") return es_es2_builds_tabs_files(inputs)
	if (locale === "es-MX") return es_mx2_builds_tabs_files(inputs)
	if (locale === "fil") return fil_builds_tabs_files(inputs)
	if (locale === "fr") return fr_builds_tabs_files(inputs)
	if (locale === "it") return it_builds_tabs_files(inputs)
	if (locale === "hu") return hu_builds_tabs_files(inputs)
	if (locale === "nl") return nl_builds_tabs_files(inputs)
	if (locale === "no") return no_builds_tabs_files(inputs)
	if (locale === "pl") return pl_builds_tabs_files(inputs)
	if (locale === "pt-BR") return pt_br2_builds_tabs_files(inputs)
	if (locale === "pt") return pt_builds_tabs_files(inputs)
	if (locale === "ro") return ro_builds_tabs_files(inputs)
	if (locale === "fi") return fi_builds_tabs_files(inputs)
	if (locale === "sv") return sv_builds_tabs_files(inputs)
	if (locale === "vi") return vi_builds_tabs_files(inputs)
	if (locale === "tr") return tr_builds_tabs_files(inputs)
	if (locale === "cs") return cs_builds_tabs_files(inputs)
	if (locale === "bg") return bg_builds_tabs_files(inputs)
	if (locale === "ru") return ru_builds_tabs_files(inputs)
	if (locale === "uk") return uk_builds_tabs_files(inputs)
	if (locale === "ar") return ar_builds_tabs_files(inputs)
	if (locale === "hi") return hi_builds_tabs_files(inputs)
	if (locale === "th") return th_builds_tabs_files(inputs)
	if (locale === "ja") return ja_builds_tabs_files(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_tabs_files(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_tabs_files(inputs)
	return ko_builds_tabs_files(inputs)
});
export { builds_tabs_files as "builds.tabs.files" }